import { FC, ReactNode, createContext, useContext, useState } from 'react';

export interface DrawersContextType {
  drawers: Map<number, boolean>;
  toggleBoolean: (key: number) => void;
  onCloseAll: () => void;
  isOpen: (key: number) => boolean;
}

export const DrawersContext = createContext<DrawersContextType>(
  {} as DrawersContextType,
);

export interface DrawersContextProviderProps {
  children?: ReactNode;
}

export const DrawersContextProvider: FC<DrawersContextProviderProps> = ({
  children,
}) => {
  const [drawers, setDrawers] = useState(new Map<number, boolean>());
  const keysArray = Array.from(drawers.keys());

  const toggleBoolean = (key: number) => {
    setDrawers(prevState => {
      const newState = new Map(prevState);
      newState.set(key, !newState.get(key));
      return newState;
    });
  };

  const isOpen = (key: number) => {
    return keysArray.includes(key);
  };

  const onCloseAll = () => {
    setDrawers(state => {
      const newState = new Map(state.entries());
      newState.keys().forEach(key => newState.set(key, false));
      return newState;
    });
  };

  return (
    <DrawersContext.Provider
      value={{
        drawers,
        toggleBoolean,
        onCloseAll,
        isOpen,
      }}
    >
      {children}
    </DrawersContext.Provider>
  );
};

export const useDrawersContext = () => useContext(DrawersContext);
